import React, { useState, useEffect } from "react";
import TextField from "@mui/material/TextField";
import { evaluate } from "mathjs"; // Install with: npm install mathjs

type CalculatorTextFieldProps = {
  value: number;
  placeholder?: string;
  setValue: (newValue: number) => void;
};

const CalculatorTextField: React.FC<CalculatorTextFieldProps> = ({ value, setValue, placeholder = "Menge" }) => {
  const [amount, setAmount] = useState<string>(value.toString());

  // Sync the local input when the external value changes
  useEffect(() => {
    setAmount(value.toString().replace(/\./g, ","));
  }, [value]);

  // Evaluate the arithmetic expression and update the value
  const handleEvaluation = (): void => {
    try {
      const result = evaluate(amount.replace(/,/g, "."));
      const numResult: number = typeof result === "number" ? result : 0;
      setValue(numResult);
    } catch (error) {
      setValue(0);
    }
  };

  return (
    <TextField
      size="small"
      fullWidth
      value={amount}
      autoFocus
      placeholder={placeholder}
      onChange={(e: React.ChangeEvent<HTMLInputElement>) => setAmount(e.target.value)}
      onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === "Enter") {
          handleEvaluation();
          e.preventDefault();
        }
      }}
      onBlur={handleEvaluation}
    />
  );
};

export default CalculatorTextField;
